import React, { Component } from 'react';

let buildVersion = require('../../version.json');

class SidebarFooter extends Component {

  render() {
    return (
      <div className="sidebar-footer">

          <small>
            {`v${buildVersion.major}.${buildVersion.minor}-${buildVersion.build}`}
          </small>

      </div>

    );

  }
}

export default SidebarFooter;



// WEBPACK FOOTER //
// ./src/components/SidebarFooter/SidebarFooter.js